export const normalizeDashboardPath = (path) =>
	path && path !== '/' ? path.replace(/\/$/, '') : path;

export const dashboardPathMatches = (
	path,
	currentPath,
	{ exact = false, excludePaths = [] } = {}
) => {
	const normalizedPath = normalizeDashboardPath(path);
	const normalizedCurrentPath = normalizeDashboardPath(currentPath);
	const excluded = excludePaths.some((excludedPath) => {
		const normalizedExcludedPath = normalizeDashboardPath(excludedPath);
		return (
			normalizedCurrentPath === normalizedExcludedPath ||
			normalizedCurrentPath?.startsWith(`${normalizedExcludedPath}/`)
		);
	});

	if (excluded) return false;
	if (exact) return normalizedPath === normalizedCurrentPath;

	return (
		normalizedPath === normalizedCurrentPath ||
		normalizedCurrentPath?.startsWith(`${normalizedPath}/`)
	);
};
